import React from "react";
import {
    Box,
    Typography,
    Avatar,
    Rating,
    Card,
    CardContent,
    Stack
} from "@mui/material";

const SalonReviews = ({ reviews }) => {
    if (!reviews || reviews.length === 0) {
        return (
            <Typography variant="body1" sx={{ mt: 2, opacity: 0.7 }}>
                No reviews yet.
            </Typography>
        );
    }
    // console.log('reviews in SalonReviews:', reviews);

    return (
        <Stack spacing={2} sx={{ mt: 1 }}>
            {reviews.map((review) => {
                const user = review.user || {};

                const initials =
                    (user.first_name?.[0] || "") + (user.last_name?.[0] || "");

                return (
                    <Card key={review.id} sx={{ borderRadius: 3 }}>
                        <CardContent>
                            <Stack direction="row" spacing={2}>
                                <Avatar
                                    src={user?.profile_pic_url}
                                    sx={{ bgcolor: "#1976d2" }}>

                                </Avatar>

                                <Box sx={{ flex: 1 }}>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                            {user.first_name} {user.last_name}
                                        </Typography>

                                        <Typography variant="caption" sx={{ color: "gray" }}>
                                            {review.formatted_date ||
                                                new Date(review.created_at).toLocaleDateString()}
                                        </Typography>
                                    </Stack>

                                    <Rating
                                        value={review.rating}
                                        precision={0.5}
                                        readOnly
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />

                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                        {review.feedback}
                                    </Typography>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                );
            })}
        </Stack>
    );
};

export default SalonReviews;
